import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signin-previously_logged_in-action_unknown';
/**
 * Event triggered whenever a visitor lands on the logged out home page. The first param is a flag indicating whether the user is a retailer that has previously logged out.
 */
export function trackSigninPreviouslyLoggedIn(Previously_logged_in) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Previously_logged_in },
    });
}
